import React from 'react';

import { getResultHit, ScreeningResultCard, TFPageContent, TFPageHeader } from '@tf/shared';
import { Box, TFLoadingOverlay } from '@tf/ui';
import { fmt, T } from '@tf/utils';

import { usePayment, useTransactionAssessmentResults } from '@/core/api/payments';
import { appStore } from '@/core/stores';

import { usePaymentAssessmentParams } from './usePaymentAssessmentParams';

export const ScreeningResults = () => {
	const { paymentObjectName, assessmentObjectName, screeningId } = usePaymentAssessmentParams();

	const { data, isPending } = usePayment(paymentObjectName);
	const { data: assessmentResults } = useTransactionAssessmentResults(paymentObjectName);

	const tenant = appStore.tenant?.get();
	T.assertNotNullish(tenant, 'no tenant in appStore');

	const assessmentResult = assessmentResults?.find((assessment) =>
		assessment.id.includes(assessmentObjectName)
	);

	if (isPending || !data || !assessmentResults || !assessmentResult) {
		return <TFLoadingOverlay />;
	}

	const assessmentCreatedAt = fmt.toDate(assessmentResult.meta['@createdAt'], {
		preset: 'full_date_with_time',
	});

	const hit = assessmentResult.data.raw_screening_response?.actor.rawResponse.hits?.find(
		(hit) => hit.doc.id == screeningId
	);

	return (
		<>
			<TFPageHeader
				tenant={tenant}
				title={hit?.doc?.name || 'N/A'}
				breadcrumbs={[
					{ href: `/payments`, title: 'Payments' },
					{ href: `/payments/${paymentObjectName}`, title: data.labels.order_id },
					{
						href: `/payments/${paymentObjectName}/assessments/${assessmentObjectName}/screenings/${hit.doc.id}`,
						title: `Assessment from ${assessmentCreatedAt}`,
					},
				]}
			/>
			<TFPageContent>
				<Box>
					<ScreeningResultCard hit={getResultHit(hit)} />
				</Box>
			</TFPageContent>
		</>
	);
};
